(() => {
  if (window.customElements.get('low-stock-signal')) {
    return;
  }

  class LowStockSignal extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('[data-low-stock-text]');
      this.variants = this.#parseVariants();
      this.baseMessage = this.dataset.baseMessage || '';
      this.lastOneMessage = this.dataset.lastOneMessage || 'ONE LEFT';
      this.soldOutMessage = this.dataset.soldOutMessage || 'SOLD OUT';
      this.lastVariantId = null;

      this.form = this.#findForm();
      if (!this.form) {
        return;
      }

      this.onVariantChange = this.onVariantChange.bind(this);
      this.onIdChange = this.onIdChange.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.form.addEventListener('variant:change', this.onVariantChange);
      this.form.addEventListener('change', this.onIdChange);
      this.idInput = this.form.querySelector('[name="id"]');
      this.idInput?.addEventListener('change', this.onIdChange);
      this.idInput?.addEventListener('input', this.onIdChange);
      this.#watchIdInputValue();

      // Swatch King replaces the native picker; catch its clicks then re-read the id.
      document.addEventListener('click', this.onDocumentClick, true);

      this.#syncFromIdInput();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('variant:change', this.onVariantChange);
      this.form?.removeEventListener('change', this.onIdChange);
      this.idInput?.removeEventListener('change', this.onIdChange);
      this.idInput?.removeEventListener('input', this.onIdChange);
      document.removeEventListener('click', this.onDocumentClick, true);
    }

    onVariantChange(event) {
      const variant = event.detail?.variant;
      if (!variant) {
        return;
      }

      this.lastVariantId = String(variant.id);
      const storedVariant = this.variants[this.lastVariantId];
      this.#applyVariant(storedVariant || {
        available: variant.available !== false && variant.available !== 'false',
        inventoryQuantity: null
      });
    }

    onIdChange() {
      this.#syncFromIdInput();
    }

    onDocumentClick(event) {
      if (!event.target.closest('variant-swatch-king, .swatch-view, .swatches')) {
        return;
      }

      requestAnimationFrame(() => {
        this.#syncFromIdInput();
        setTimeout(() => this.#syncFromIdInput(), 50);
        setTimeout(() => this.#syncFromIdInput(), 150);
      });
    }

    #syncFromIdInput() {
      const variantId = this.idInput?.value;
      if (!variantId || variantId === this.lastVariantId) {
        if (variantId && Object.prototype.hasOwnProperty.call(this.variants, variantId)) {
          this.#applyVariant(this.variants[variantId]);
        }
        return;
      }

      this.lastVariantId = variantId;

      if (Object.prototype.hasOwnProperty.call(this.variants, variantId)) {
        this.#applyVariant(this.variants[variantId]);
      }
    }

    #applyVariant(variant) {
      let message = this.baseMessage;

      if (!variant.available) {
        message = this.soldOutMessage;
      } else if (variant.inventoryManagement && Number(variant.inventoryQuantity) === 1) {
        message = this.lastOneMessage;
      }

      if (this.textEl) {
        this.textEl.textContent = message;
      }

      this.hidden = message === '';
    }

    #watchIdInputValue() {
      if (!this.idInput || this.idInput.dataset.lowStockWatched === 'true') {
        return;
      }

      this.idInput.dataset.lowStockWatched = 'true';
      const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
      if (!descriptor?.get || !descriptor?.set) {
        return;
      }

      const input = this.idInput;
      const self = this;

      Object.defineProperty(input, 'value', {
        configurable: true,
        get() {
          return descriptor.get.call(this);
        },
        set(next) {
          const previous = descriptor.get.call(this);
          descriptor.set.call(this, next);
          if (String(previous) !== String(next)) {
            self.#syncFromIdInput();
          }
        }
      });
    }

    #findForm() {
      const rerender = this.closest('product-rerender');
      const formId = rerender?.getAttribute('observe-form');
      if (formId && document.forms[formId]) {
        return document.forms[formId];
      }

      return this.closest('form') || document.querySelector('form[action*="/cart/add"]');
    }

    #parseVariants() {
      const script = this.querySelector('[data-low-stock-variants]');
      if (!script) {
        return {};
      }

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return {};
      }
    }
  }

  window.customElements.define('low-stock-signal', LowStockSignal);
})();
